export const TEAMS = {
    accounts: "Accounts",
    support: "Support",
    booking_care: "Booking & Visit Care",
    emergency: "Emergency Escalation",
    hr: "HR",
};

export const ESC_TONE = {
    Assigned: "bg-amber-50 text-amber-700",
    Accepted: "bg-sky-50 text-sky-700",
    "In progress": "bg-violet-50 text-violet-700",
    Resolved: "bg-emerald-50 text-emerald-700",
    "Sent back": "bg-red-50 text-red-700",
};
